export default {
  common: {
    campany: 'COMPANY',
    ourStory: 'ARTIST',
    audition: 'AUDITION',
    contact: 'CONTACT',
    information: 'INFORMATION',
    blix: 'BLIX CREATES THE FUTURE OF ENTERTAINMENT —',
    makingTomorrow: 'MAKING TOMORROW’S',
    inspirations: 'INSPIRATIONS POSSIBLE TODAY',
    home: 'HOME',
    copyrightBlix: '© Copyright Blix Entertainment. ALL RIGHT RESERVED',
    standsFor: '"BLIX" STANDS FOR',
    brilltance: 'BRILLIANCE.',
    speed: 'SPEED.',
    stability: 'STABILITY.',
    vitality: 'VITALITY.',
    tip: 'BLIX는 글로벌 엔터테인먼트 회사로서 아티스트 발굴, 육성, 음악 제작, 기술 혁신을 기반으로 음악 제작과 기술 혁신을 결합하여 세계 시장에 경쟁력 있는 콘텐츠와 창의적인 스토리텔링을 아우르는 통합 생태계를 구축하는 미래 지향적 크리에이티브 엔터테인먼트입니다.우리는 글로벌 무대에서 한국 엔터테인먼트의 새로운 기준을 세우는 기업이 될 것입니다.',
    tip1: '창의성이 우리의 지속적인 힘이며, BLIX는 그 힘으로 세계를 움직인다 믿습니다. 창의성은 계속해서 불타오르고, 멈추지 않는 에너지로 세상에 새로운 영감을 전합니다. ',
    tip2: 'BLIX는 체계적인 구조의 엔터테인먼트 시스템으로 운영하며, 스토리와 아티스트,그리고 전 세계 팬들을 하나로 연결하여 최적에 엔터테인을 제공할 것입니다.',
    tip3: 'BLIX는 창의성과 전문성을 결합한 체계적인 시스템으로 아티스트의 성장 전 과정부터 전문 트레이닝을 통해 음악 제작/비주얼 스토리텔링/브랜딩, 그리고 글로벌 무대까지 연결되는 견고한 시스템을 통해 체계적이고 지속 가능한 엔터테인먼트 산업의 장기적 영향력을 구축할 것입니다.',
    visionary: 'VISIONARY ENTERTAINMENT',
    tip4: '빠르게 변화하는 글로벌 시장 및 창조경제 시장속에서, BLIX는 지속 가능하고 유연한 엔터테인먼트 시스템을 구축했습니다. 모든 단계는 전문적인 기준과 양성, 미래지향적인 비전을 바탕으로 정교하게 설계되어, 새로운 엔터테인먼트의 방향을 제시합니다. ',
    atTheHeart:'BLIX의 중심에는 끝없는 가능성과 새로운 비전이 있습니다. ', 
    wePrepare:'우리는 트렌드를 넘어, 세대를 이끌 문화의 무대를 준비합니다. ', 
    togetherWeGrow:'함께 성장하며, 세계 속에서 새로운 기준이 되는 BLIX 엔터테인먼트가 되겠습니다. ',
    ourCompleteSystem: 'OUR COMPLETE SYSTEM',
    casting: 'CASTING',
    trainingDevelopment: 'TRAINING & DEVELOPMENT',
    musicProduction: 'MUSIC PRODUCTION',
    brandingStoryIP: 'BRANDING & STORY IP',
    marketingFanSystem: 'MARKETING & FAN SYSTEM',
    globalBusiness: 'GLOBAL BUSINESS',
    crossIndustryCollaboration: 'CROSS-INDUSTRY COLLABORATION',
    weContinue: 'BLIX는 문화 혁신가들과 함께 성장하며, 아티스트 양성 및 활동 또는 다음과 같은 분야와 협력하고 있습니다',
    artists: 'ARTISTS',
    technologyDevelopers: 'TECHNOLOGTY',
    creativeStrategists: 'CREATIVE STRATEGISTS',
    weBelieve: 'BLIX는 문화 혁신가들과 함께 성장하며, 아티스트 양성 및 활동 또는 다음과 같은 분야와 협력하고 있습니다',
    atBlix:'BLIX는 아티스트의 꿈이 곧 우리의 미래라고 믿습니다.',
    thatFunture:'그 미래는 이미, 이곳에서 음악과 이야기로 현실이 되고 있습니다.',
    creativeSpace: 'CREATIVE SPACE',
    tip5: 'BLIX의 글로벌 아티스트 프로젝트와  함께, 세계 무대로 향하는 새로운 서막이 열립니다',
    spotlight: 'Join BLIX — 세계 무대로 향하는 아티스트의 여정, BLIX에서 시작됩니다.',
    blixShien: 'BLIX는 차세대 아티스트들이 전문적안 트레이닝으로 인해 성장하고 빛을 발할 수 있는 최적의 환경을 제공할 것입니다',
    tip20: 'BLIXビルは、トレーニング・音楽・ビジュアル制作を一体化したクリエイティブベースです。アイデアが自由に広がり、クリエイティビティが絶えず進化し続けます。',
    forYou: '세계 무대로 향하는 첫걸음, BLIX는 당신을 기다리고 있습니다',
    apllyNow: 'APLLY NOW',
    pleaseleave:'문의 내용을 보내주시면, 저희 팀이 확인 후 답변 드리겠습니다.',
    name:'이름',
    email:'이메일',
    contactNumber:'연락처 번호',
    inquiryDetails:'문의 세부 사항',
    contact2:"CONTACT",
    agreePolicy:'개인 정보 보호 정책에 동의합니다.',
    submitInquiry:'문의를 제출',
    seoulHq:'SEOUL HQ ',
    add:'6 SEONGMISAN-RO 6-GIL, ',
    add1:'MAPO-GU, SEOUL, ',
    add2:'REPUBLIC OF KOREA [03996]',
    add3:'서울특별시 마포구 성미산로6길 6 (망원동, BLIX 빌딩) ',
    hongKong:'HONG KONG OFFFICE',
    midtown:'1811, ONE MIDTOWN,',
    hoiShing:'11 HOI SHING ROAD, TSUEN WAN,',
    hongKong1:' HONG KONG',
    onlineAuditin:'온라인 오디션 가이드',
    auditionCategories:'오디션 카테고리',
    dataTyle:'보컬/랩/댄스/퍼포먼스',
    applicationPeriod:'지원 기간',
    openYearRound:'연중 상시 접수 ', 
    eligibility:'지원 자격', 
    noRestrictions:'제한 없음 – 누구나 지원 가능', 
    howToApply:'신청 방법',
    step1:'단계 1',
    auditionForm:'‘지원하기’ 버튼을 클릭하고 오디션 신청서를 작성해주세요.',
    step2:'단계 2',
    uploadRequired:'제출 파일 업로드',
    photos:'사진 ',
    clearPhoto:'상반신 정면 사진 1장',
    frontView:'전신 정면 사진 1장',
    videoSubmission:'영상 제출 ',
    videoAudio:'보컬/랩: 최소 1분 이상의 노래 또는 랩 (영상 또는 음성 파일)',
    freestyledancing:'댄스: 최소 1분 이상의 프리스타일 댄스 영상',
    actingPerformance:'연기: 최소 1분 이상의 독백 또는 연기 영상',
    step3:'단계 3',
    submityour:'지원서를 제출하면 오디션 절차가 완료됩니다.',
    auditionProcess:'오디션 절차 (Audition Process)',
    stRound:'1차 서류 심사 ',
    videoSubmissionReview:'지원서, 사진, 영상 제출물을 심사합니다.',
    ndRound:'2차 카메라 테스트 ',
    recordedVideoTest:'선발된 지원자는 녹화 영상 테스트에 참여합니다.',
    rdRound:'3차 최종 오디션 & 결과 통보 ',
    afterThisRound:'최종 후보자는 현장 오디션에 초대되며, 이 단계에서 최종 결과가 결정됩니다.',
    auditionResults:'오디션 결과 ',
    tip6:'합격자는 지원서에 기재된 이메일 또는 전화로 개별 통보되며, 오디션일로부터 2주 이내에 안내됩니다.',
    auditionResultsNotification:'오디션 결과 통보',
    tip7:'선발된 지원자에 한해, 지원서에 기재된 이메일 주소 또는 전화번호로 개별 연락을 드립니다. 오디션일로부터 2주 이내에 결과가 안내됩니다.',
    importantNotes:'유의사항',
    beReturned:'제출된 자료는 반환되지 않습니다.',
    anyPhotosThat:'과도하게 보정되거나 필터가 적용된 사진(예: 포토샵 사용)은 서류 심사에서 탈락될 수 있습니다.',
    videosAudio:'저화질 영상 또는 음성(예: 흐릿함, 초점 불량, 음질 불량 등)은 심사에 불이익이 있을 수 있습니다.',
    questionsFurther:' 문의사항이 있거나 추가 도움이 필요할 경우 아래 이메일로 연락해 주십시오:',
    apply:'APPLY',
    pleaseEnter1:'오디션 지원을 위해 정확한 정보를 입력해 주십시오.',
    emailAddress:'이메일 주소',
    VerifyEmail:'이메일 확인',
    lastName:'성씨',
    firstName:'성씨',
    dateOfBirth:'생년월일',
    select:'선택해주세요',
    enter:'입력하십시오.',
    profilePicture:'프로필 사진',
    upload:'업로드',
    pleaseUpload:'올려주세요.',
    performanceCategory:'퍼포먼스 카테고리',
    gender:'성별',
    height:'키',
    height1:'키(CM)',
    weight:'몸무게',
    weight1:'몸무게(KG)',
    phone:'전화번호',
    phone1:'양식에 기입해 주십시오',
    schoolJob:'학교/직업',
    schoolJob1:'양식에 기입해 주십시오',
    emergencyContact:'비상 연락처',
    emergencyContact1:'양식에 기입해 주십시오',
    placeOfresidence:'거주지',
    socialMediaId:'소셜미디어 ID',
    specialtv:'특기',
    activtiesAwarsds:'활동 및 수상 경력',
    activtiesExperience:'오디션 경험',
    specialNote:'특이사항',
    attachFile:'ATTACH FILE',
    profileAttachFile:'프로필 첨부 파일',
    consentInformation:'나는 나의 개인 정보를 수집하고 사용하는 것에 동의한다.',
    submitApplicatior:'지원서 제출',
    tit1:'[개인 정보 수집 및 사용]',
    tip8:'지원자는 BLIX 엔터테인먼트(이하 "회사")가 아래 목적을 위해 개인정보를 수집 및 이용하는 데 동의합니다.',
    tip9:"수집 목적 및 항목: 성명, 생년월일, 국적, 주소, 이메일, 연락처, 나이, 키, 체중, 수상 및 학력, 학교 및 학년, SNS 계정, 사진 및 영상.",
    tip10:"신원 확인, 오디션 지원 관리, 재능 평가, 연습생 선발 관련 절차 진행. 수집 항목: 성명, 생년월일, 국적, 주소, 이메일, 연락처, 나이, 키, 체중, 수상 및 학력, 학교 및 학년, SNS 계정, 사진 및 영상.",
    tip11:"보유 및 이용 기간: 동의일로부터 2년간 보관·이용하며, 지원자가 서면 철회 시까지 유효. 정보 변경 시 회사에 즉시 통보해야 함.",
    tip12:"지원자는 제공한 정보에 변경 사항이 있을 경우 즉시 회사에 통보해야 하며, 회사는 동일한 조건으로 갱신된 정보를 수집 및 활용할 수 있습니다.",
    tip13:"동의를 거부할 경우 신청이 불가하거나 오디션 관련 절차가 진행되지 않을 수 있으며, 이로 인한 불이익은 전적으로 지원자의 책임입니다.",
    tit2:'[개인정보 제3자 위탁]',
    tip14:'위탁 목적: BLIX 엔터테인먼트 오디션 플랫폼과 관련 데이터를 서버를 통해 안전하게 운영 및 관리하기 위함.',
    tip15:"지원자는 제3자 데이터 처리에 대한 동의를 거부할 권리가 있습니다. 다만, 거부 시 공식 플랫폼을 통한 오디션 참가가 제한될 수 있습니다.",
    tit3:'[콘텐츠 기록 및 사용 동의]',
    tip16:'지원자는 오디션 과정 중 회사가 본인의 음성, 영상, 사진을 기록·촬영·활용하는 데 동의합니다. 모든 기록물(“콘텐츠”)은 평가, 내부 사용, 기록 보관, 인재 개발 및 계약 체결 시 활용될 수 있습니다.',
    tit4:'[콘텐츠의 지식재산권]',
    tip17:'콘텐츠와 관련된 모든 저작권(2차적 저작물 작성권 포함), 초상권, 그리고 기타 일체의 지식재산권은 BLIX ENTERTAINMENT가 전 세계적으로 독점 소유합니다. 지원자는 서면으로 별도의 합의가 없는 한, 콘텐츠와 관련하여 소유권, 로열티, 보상 등에 대한 어떠한 권리도 주장하지 않습니다.',
    pleaseSelect:'선택해주세요',
    pleaseCheck:'프로토콜을 선택하십시오.',
    submissionSuccessful :'선택하십시오.',
    male:'Male',
    female:'Female',
    submissionFailed:'제출 실패',
    pleaseEmailAddress:'이메일 주소를 입력하십시오.',
    sentSuccessfully:'성공적으로 전송',
    attachFile:'파일 첨부',
    imageFileSuch:'.jpg.png/MAX 50MB 같은 이미지 파일',
    fileSize:'파일 크기는 50MB 미만이어야 합니다!',
    fileSize1:'파일 크기는 100MB 미만이어야 합니다!',
    uploadFailed:'업로드 실패',
    attach:'첨부',
    emailVerification:'이메일 확인을 보내지 못했습니다.',
    privacyPolicy:'개인정보 처리방침',
    tip21:'BLIX Entertainment(이하 “회사”)는 이용자의 개인정보를 존중하며, 이를 보호하기 위해 최선을 다하고 있습니다. 본 방침은 당사가 웹사이트 및 서비스를 제공하는 과정에서 개인정보를 어떻게 수집, 이용, 보관, 보호하는지 설명합니다.',
    tip22:'1. 수집하는 개인정보 항목',
    tip23:'•	문의 시 제공되는 이름, 이메일, 연락처 등',
    tip24:'•	IP 주소, 브라우저 종류, 접속 기록 등 기술 정보',
    tip25:'2. 개인정보 이용 목적',
    tip26:'•	고객 문의에 대한 답변 및 지원 제공',
    tip27:'•	웹사이트 및 서비스 개선',
    tip28:'•	법적 의무 준수',
    tip29:'3. 개인정보 제공 및 공유',
    tip30:'•	회사는 개인정보를 판매하거나 임대하지 않습니다.',
    tip31:'•	서비스 운영을 위해 신뢰할 수 있는 외부 업체와 공유할 수 있습니다.',
    tip32:'•	법령에 따라 요구되는 경우 제공할 수 있습니다.',
    tip33:'4. 보유 및 이용기간',
    tip34:'•	수집 목적 달성 시까지 개인정보를 보관하며, 이후에는 지체 없이 파기합니다.',
    tip35:'5. 개인정보 보호 조치',
    tip36:'•	합리적인 보안 조치를 취하고 있으나, 완전한 안전성을 보장할 수는 없습니다.',
    emailUnverified:'메일박스가 검증되지 않았습니다.',
    tip37:'BLIX HEADQUARTERS IS IN A MULTI-LEVELCREATIVE COMPLEX,WHERE EACH FLOORIS DEDICATED TO A SPECIALIZED FUNCTION-TRAINING, MUSICPRODUCTION, VISUAL DEVELOPMENT AND CONCEPT CREATION.',
    tip38:'창의성과 혁신 기술이 결합하여 다음 시대의 엔터테인먼트를 만들어갑니다.',
    year:'연도',
    award:'시상식',
    categoryWork:'부문 / 작품',
    brandOfTheYearAwards:'올해의 브랜드 대상',
    femaleVocalist:'여성 보컬',
    rdKYStarAwards:'제3회 KY 스타 어워즈',
    millionSongLogs:'천만곡 로그상',
    gaonChartMusicAwards:'제9회 가온차트 뮤직 어워즈',
    discoveryoftheYearBallad:'올해의 발견상 (발라드)',
    melonMusicAwards:'멜론뮤직어워드',
    topArtists:'TOP10 아티스트',
    songDayWasBeautiful:'올해의 노래 (대상) – 그때가 좋았어',
    bestBallad:'베스트 발라드',
    goldenDiscAwards:'제34회 골든디스크 어워즈',
    digitalBonsang:'디지털 본상',
    seoulMusicAwards:'제29회 서울가요대상',
    bonsangMainPrize:'본상',
    popularityAward:'인기상v',
    KWaveAwards:'K-Wave 어워즈',
    bestAwardRewind:'Best R&B (Rewind)',
    koreaCulturalEntertainmentAwards:'대한민국 문화연예대상',
    kStarAward:'K-POP 스타상',
    artistTheYear:'올해의 아티스트',
    topArtistAward:'TOP10 아티스트',
    bestFemaleSoloArtist:'베스트 여성 솔로',
    tip39:"BLIX 빌딩은 트레이닝, 음악, 비주얼 프로덕션이 하나의 크리에이티브 생태계로 연결된 공간입니다. ",
    tip40:"이곳에서 아이디어는 자유롭게 확장되고, 크리에이티브는 끊임없이 진화합니다.",
  },
};